module.exports = __webpack_public_path__ + "img/120.a60339d1.png";